// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"4f5f9f6d","398":"12e17742","615":"21c05bc4","935":"bd287dc7"}[chunkId] + ".chunk.js";
};